import { Injectable } from '@angular/core';
import { ObservableService } from '@damofire/data-angular-commons';
import { SearchResult } from '@damofire/data-commons';
import { WarehouseOutlineSegment } from '../warehouse/warehouse.dto';
import { cloneDeep } from 'lodash-es';

export function generateAndAssignOutlineIds(segments: WarehouseOutlineSegment[]): WarehouseOutlineSegment[] {
  const timestamp: number = Date.now();

  return segments.map((segment, index) =>
    segment._id
      ? segment
      : {
          ...cloneDeep(segment),
          _id: `${timestamp + index}`,
        },
  );
}

@Injectable()
export abstract class WarehouseOutlineService extends ObservableService<WarehouseOutlineSegment> {
  protected constructor() {
    super();
  }

  abstract search(divisionId: string): Promise<SearchResult<WarehouseOutlineSegment>>;
  abstract create(divisionId: string, segments: WarehouseOutlineSegment[]): Promise<void>;
  abstract delete(divisionId: string, segments: WarehouseOutlineSegment[]): Promise<void>;
  abstract update(divisionId: string, segments: WarehouseOutlineSegment[]): Promise<void>;
}
